import { createContext } from 'react';

import type { DepartmentContextValue } from './types';

// コンテキストを作成 (初期値は null)
export const DepartmentContext = createContext<DepartmentContextValue | null>(
  null
);
